import { render, staticRenderFns } from "./iadebiletfatura.vue?vue&type=template&id=3981ffa4&"
import script from "./iadebiletfatura.vue?vue&type=script&lang=js&"
export * from "./iadebiletfatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports